export enum EStateUrls {
  SUPPORTEDSTATES = 'supported-states',
  STATEPOLICY = 'statePolicy',
}
